const BowtieWebPath = {
  App: {
    Home: '/',
    EmbeddedNav: '/nav',
    Addon: {
      RecommendationQuestionFlow: '/addon/recommendation-question-flow',
      RecommendationResult: '/addon/recommendation-result'
    },
    Apply: '/apply',
    ApplyActivation: '/apply/new/activation/:token?',
    ApplyNew: '/apply/new',
    ApplyStart: '/apply/start',
    ApplyUnderwriting: '/apply/underwriting',
    ApplySave: '/apply/save',
    ApplyFollowUp: '/apply/follow-up',
    ApplySorry: '/apply/sorry',
    ApplyPostponement: '/apply/postponement',
    ApplySubmitted: '/apply/submitted',
    Manage: '/manage',
    ManageApplication: {
      Root: '/manage/a/:id',
      Details: '/manage/a/:id/details',
      Update: '/manage/a/:id/update'
    },
    ManageApplications: '/manage/a',
    ManagePolicy: {
      Root: '/manage/p/:id',
      PolicyAddOn: '/manage/p/:id/add-on',
      PolicyDetails: '/manage/p/:id/details',
      PolicyHistory: '/manage/p/:id/history',
      PolicyInvoices: '/manage/p/:id/invoices',
      PolicyRenewal: '/manage/p/:id/renewal',
      PolicySwitch: '/manage/p/:id/switch',
      PolicyModification: '/manage/p/:id/modification',
      PolicyTaxReport: '/manage/p/:id/tax-report',
      PolicyChangeFlow: {
        Root: '/manage/p/:id/modification/product-change',
        Confirmation: '/manage/p/:id/modification/product-change/confirmation',
        Options: '/manage/p/:id/modification/product-change/options',
        Splash: '/manage/p/:id/modification/product-change/splash',
        Suboptions: '/manage/p/:id/modification/product-change/suboptions',
        Underwriting: '/manage/p/:id/modification/product-change/underwriting',
        Terms: '/manage/p/:id/modification/product-change/terms',
        Submitted: '/manage/p/:id/modification/product-change/submitted',
        PremiumPayment: '/manage/p/:id/modification/product-change/premium-payment',
        Affordability: '/manage/p/:id/modification/product-change/affordability'
      },
      PolicyTerminationFlow: {
        Root: '/manage/p/:id/modification/termination-flow',
        Feedback: '/manage/p/:id/modification/termination-flow/feedback',
        Suggestions: '/manage/p/:id/modification/termination-flow/suggestions',
        Offer: '/manage/p/:id/modification/termination-flow/offer',
        OfferAccepted: '/manage/p/:id/modification/termination-flow/offer-accepted',
        Reminder: '/manage/p/:id/modification/termination-flow/reminder',
        Terms: '/manage/p/:id/modification/termination-flow/terms',
        Terminated: '/manage/p/:id/modification/termination-flow/terminated',
        WhatsappConsent: '/manage/p/:id/modification/termination-flow/whatsapp-consent'
      },
      PolicyTermination: '/manage/p/:id/termination',
      PolicyPaymentMethod: '/manage/p/:id/payment-method',
      Voucher: '/manage/p/:id/voucher',
      BenefitAndClaim: '/manage/p/:id/benefit-claim',
      RewardHistory: '/manage/p/:id/reward-history'
    },
    ManagePolicies: '/manage/p',
    MyPolicies: {
      Policy: '/my-policies/p/:id/(.*)?',
      Application: '/my-policies/a/:id/(.*)?'
    },
    Claims: {
      Root: '/claims',
      History: '/claims/history',
      FAQ: '/claims/faq',
      ClaimCase: {
        Root: '/claims/history/:claimId',
        Settlement: '/claims/history/:claimId/settlements',
        Update: '/claims/history/:claimId/update'
      },
      Estimation: '/claims/estimation',
      Submission: '/claims/submission',
      PreApproval: '/claims/pre-approval',
      Forms: '/claims/forms'
    },
    CustomerService: '/customer-service',
    Referral: '/referral',
    Settings: '/settings',
    AccountSettings: {
      Root: '/account',
      BowtieCash: '/account/bowtie-cash',
      PhoneNumber: {
        Root: '/account/phone-number',
        Update: '/account/phone-number/update',
        Verify: '/account/phone-number/verify'
      },
      Security: {
        Root: '/account/security',
        Password: '/account/security/password',
        Mfa: '/account/security/mfa'
      },
      Address: '/account/address',
      Language: '/account/language',
      Notification: '/account/notification',
      Payments: '/account/payments'
    },
    Login: '/login',
    Register: '/register',
    ForgotPassword: '/forgot-password',
    Health: {
      Root: '/health',
      Voucher: {
        Root: '/health/voucher',
        Detail: '/health/voucher/:base64id'
      },
      Marketplace: {
        Root: '/health/marketplace',
        Item: '/health/marketplace/:itemSlug',
        Redeem: '/health/marketplace/:itemSlug/redeem'
      },
      Profile: {
        Root: '/health/profile',
        Detail: '/health/profile/:id',
        Voucher: '/health/profile/:id/voucher'
      },
      Balance: {
        Root: '/health/balance'
      },
      Network: {
        Root: '/health/network',
        Panel: '/health/network/:panel/:policy_number'
      },
      FindDoctor: {
        Root: '/health/find-doctor'
      }
    },
    IdentityVerification: {
      Root: '/identity-verification'
    },
    RedeemSecret: '/s/:token?',
    ResumeApplicationCase: '/application-case/:id/resume',
    ProductChange: {
      Root: '/product-change',
      Item: {
        Root: '/product-change/:id',
        SubmissionFlow: '/product-change/:id/flow',
        Details: '/product-change/:id/details'
      }
    }
  },
  Nav: '/',
  Group: {
    Portal: '/portal'
  }
};
export default BowtieWebPath;